module.exports = __webpack_public_path__ + "static/couture05-sq-95f5d6d9146a20b35c173198800fbe01.png";